import React from 'react'
import { useRegionStore, selectRegionChanging } from '../../../store/regionStore'
import MyAutocomplete from '../index'

function StatesAutocomplete({ states, selectedStateCode, onChange, inputTextColor, popupIndicatorColor, fontSizeAdjust, transparentBorder, fullWidth }) {
  // The in-place region-change loading flag (Overmind retirement, Phase D2): the
  // former Overmind GLOBAL `state.isLoading` that selectedCountryChanged raised to
  // disable the state/province picker during the region refetch now lives on the
  // Zustand region store as `isRegionChanging`, set by hooks/useRegionChange
  // (changeRegion). SSR-false, so no hydration effect.
  const isRegionChanging = useRegionStore(selectRegionChanging)

  const selectedState = states.find(s => s.code === selectedStateCode)

  return (
    <MyAutocomplete
      isLoading={isRegionChanging}
      options={states}
      getOptionLabel={(option) => option && option.name}
      value={selectedState || null}
      onChange={(value) => onChange(value)}
      inputTextColor={inputTextColor}
      popupIndicatorColor={popupIndicatorColor}
      fontSizeAdjust={fontSizeAdjust}
      transparentBorder={transparentBorder}
      fullWidth={fullWidth}
      ariaLabel="Select state or province"
      autoComplete="address-level1"
      name="state"
    />
  )
}

export default StatesAutocomplete
